/** Pure first-touch attribution policy shared by edge middleware and browser code. */

import { NON_ACQUISITION_REDIRECT_PREFIXES } from "./private-route-policy";

export const REDIRECT_LANDING_COOKIE = "ish_redirect_landing_v1";

export function normalizedLandingPath(value: string | null | undefined): string {
  const raw = (value || "/").split("?")[0].split("#")[0] || "/";
  const withLeadingSlash = raw.startsWith("/") ? raw : `/${raw}`;
  // `/x/index.html` is the directory-index spelling of `/x/`, so a 301 from one
  // to the other (src/middleware.ts indexDocumentRedirect) is the same landing.
  const collapsed = withLeadingSlash.replace(/\/{2,}/g, "/").replace(/\/index\.html$/i, "/");
  return collapsed.length > 1 ? collapsed.replace(/\/+$/, "") : "/";
}

export function shouldPersistLandingPath(pathname: string): boolean {
  const path = normalizedLandingPath(pathname);
  return !NON_ACQUISITION_REDIRECT_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}
